var _defs, _circle, _path, _path2, _circle2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _ellipse2, _ellipse3, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeductionOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVG_ID_0_90cf9e32a3abab8ed335de487b3191f38d5ea96fe35af9808fd7933f6041bc18",
    x1: 92.65,
    y1: 113.45,
    x2: 138.64,
    y2: 113.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a0399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVG_ID_1_90cf9e32a3abab8ed335de487b3191f38d5ea96fe35af9808fd7933f6041bc18",
    "data-name": "SVG_ID_0_90cf9e32a3abab8ed335de487b3191f38d5ea96fe35af9808fd7933f6041bc18",
    x1: 75.15,
    y1: 27.98,
    x2: 117.41,
    y2: 27.98,
    xlinkHref: "#SVG_ID_0_90cf9e32a3abab8ed335de487b3191f38d5ea96fe35af9808fd7933f6041bc18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVG_ID_2_90cf9e32a3abab8ed335de487b3191f38d5ea96fe35af9808fd7933f6041bc18",
    "data-name": "SVG_ID_0_90cf9e32a3abab8ed335de487b3191f38d5ea96fe35af9808fd7933f6041bc18",
    x1: 80.45,
    y1: 116.49,
    x2: 141.58,
    y2: 116.49,
    xlinkHref: "#SVG_ID_0_90cf9e32a3abab8ed335de487b3191f38d5ea96fe35af9808fd7933f6041bc18"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_stroke",
    cx: 106.74,
    cy: 118.81,
    r: 3.28
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M127.99 107.05l-5.34-.93M126.14 111.98s2.56 3.38 5.63 1.8M124.63 100.4c-3.07 1.58-1.98 5.72-1.98 5.72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M133.72 113.75l15.46 6.72M140.68 76.63l24.06 11.34M159.5 116.94l8.89-18.87M164.76 87.98c-1.78 3.79-.16 8.31 3.63 10.09M159.5 116.94a7.593 7.593 0 00-10.1 3.64"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 155.71,
    cy: 103.54,
    r: 3.28
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M138.12 123.04l21.44 9.38 20.94-44.53-38.13-17.93-15.39 31.65"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M129.34 98.75c3.13 1.47 5.75-1.91 5.75-1.91l-2.71-5.19M137.92 90.38s1.13-4.09-2-5.56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M120.83 91.39l-23.65 12.18a7.59 7.59 0 01-3.26 10.22h-.02l9.55 18.37v.08a7.59 7.59 0 0110.22 3.26l.19.02 23.53-12.13",
    stroke: "url(#SVG_ID_0_90cf9e32a3abab8ed335de487b3191f38d5ea96fe35af9808fd7933f6041bc18)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M94.03 130.85H61.71c-2.31 0-4.19-2.08-4.19-4.64V30.55c0-2.56 1.88-4.64 4.19-4.64H77.3M115.26 25.91h15.59c2.31 0 4.19 2.08 4.19 4.64v53.91"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVG_ID_1_90cf9e32a3abab8ed335de487b3191f38d5ea96fe35af9808fd7933f6041bc18)",
    d: "M112.25 33.61l4.06-11.27H76.25l4.06 11.27h31.94z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M107.01 69.52a8.18 8.18 0 017.57-5.08c3.86 0 7.09 2.68 7.95 6.28M70.03 70.84c.81-3.66 4.07-6.4 7.98-6.4 4.23 0 7.7 3.21 8.13 7.33"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 114.78,
    cy: 59.78,
    rx: 4.75,
    ry: 4.67
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 97.18,
    cy: 57.41,
    rx: 6.71,
    ry: 6.6
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 78.02,
    cy: 59.78,
    rx: 4.75,
    ry: 4.67
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M85.16 75.36C85.73 69.32 90.82 64.6 97 64.6s11.22 4.68 11.83 10.67"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVG_ID_2_90cf9e32a3abab8ed335de487b3191f38d5ea96fe35af9808fd7933f6041bc18)",
    d: "M117.83 85.3L81.7 103.96l22.58 43.72 36.05-18.62-22.5-43.76z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeductionOverview);
export default __webpack_public_path__ + "static/media/deductionOverview.98415af993afd1b73b80ab69fa940852.svg";
export { ForwardRef as ReactComponent };